// Mission Control context preference is stored in a cookie (not localStorage)
// so the App Router server page can read it on first render and avoid the
// candidate↔company layout flash after hydration.

export const MC_CONTEXT_COOKIE = 'mc_context';

export type McContextCookieValue = 'candidate' | 'company';

const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

export const isMcContextCookieValue = (value: unknown): value is McContextCookieValue => (
  value === 'candidate' || value === 'company'
);

const cookieAttributes = (): string => {
  const secure = typeof location !== 'undefined' && location.protocol === 'https:' ? '; Secure' : '';
  return `path=/; SameSite=Lax${secure}`;
};

export const readMcContextCookieClient = (): McContextCookieValue | undefined => {
  if (typeof document === 'undefined') return undefined;
  const prefix = `${MC_CONTEXT_COOKIE}=`;
  const row = document.cookie.split('; ').find((entry) => entry.startsWith(prefix));
  if (!row) return undefined;
  const raw = decodeURIComponent(row.slice(prefix.length));
  return isMcContextCookieValue(raw) ? raw : undefined;
};

export const writeMcContextCookieClient = (value: McContextCookieValue): void => {
  if (typeof document === 'undefined') return;
  document.cookie = `${MC_CONTEXT_COOKIE}=${value}; max-age=${ONE_YEAR_SECONDS}; ${cookieAttributes()}`;
};

export const clearMcContextCookieClient = (): void => {
  if (typeof document === 'undefined') return;
  document.cookie = `${MC_CONTEXT_COOKIE}=; max-age=0; ${cookieAttributes()}`;
};
